import "flatpickr/dist/themes/material_blue.css";
import "../../assets/scss/datatables.scss";

import * as loadingAction from "../../store/loading/action";
import * as messageAction from "../../store/message/action";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  GET_ALARM_DATA,
  SAVE_ALARM_DATA,
  SAVE_LIST_ALARM_DATA,
  MANUAL_REFRESH_ALARM,
} from "../../helpers/url_api_constant";
import { Link, useHistory } from "react-router-dom";

import React, { useEffect, useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import cellEditFactory from "react-bootstrap-table2-editor";
import { connect, useDispatch } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../helpers/api_helper";
import { withTranslation } from "react-i18next";
import { getPermission } from "../../helpers/auth_helper";

//i18n

function AlarmManagement(props) {

  let history = useHistory();
  const dispatch = useDispatch();
  const permission = getPermission();
  const searchObj = {
    SELECT_DATE: moment(new Date()).format("YYYY-MM-DD"),
    // SELECT_DATE: moment(new Date().setDate(new Date().getDate() - 1)).format(
    //   "YYYY-MM-DD"
    // ),
  };
  // const searchObj = { SELECT_DATE:""};
  // console.log(searchObj);
  const createObj = { PID: "", DASHBOARD_DESC: "" };
  const [modelDeviceList, setModelDeviceList] = useState([]);

  const [listAlarmMedium, setListAlarmMedium] = useState([]);
  const [listAlarmUrgent, setListAlarmUrgent] = useState([]);
  const [selectedListUrgent, setSelectedListUrgent] = useState([])
  const [selectedListMedium, setSelectedListMedium] = useState([])
  const [disabledListUrgent, setDisabledListUrgent] = useState([])
  const [disabledListMedium, setDisabledListMedium] = useState([])
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [tempSearch, setTempSearch] = useState({
    // SELECT_DATE: new Date().setDate(new Date().getDate() - 1),
    SELECT_DATE: new Date(),
  });

  // const [showDate, setShowDate] = useState(searchObj.SELECT_DATE);
  const [showDate, setShowDate] = useState(moment(searchObj.SELECT_DATE).add(-1, 'day'));

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];

  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const manualKeyAlarmUrgent = (cellContent, row) => {
    return (
      <AvForm className="needs-validation">
        <div>
          <AvField
            type="textarea"
            name="DASHBOARD_DESC"
            errorMessage="Enter Case"
            className="form-control"
            maxLength="230"
            // style={{ border: "solid 1px #FFFFFF", color: "#FFFFFF" }}
            // style={{ border: "solid 1px #000000", backgroundColor: "#FFFFFF", color: "#000000" }}
            // validate={{ required: { value: true } }}
            readOnly={row.DASHBOARD_FLAG == false}
            onChange={e =>
              setListAlarmUrgent(prevData => {
                return prevData.map(item => {
                  if (item.PID === row.PID) {
                    return { ...item, DASHBOARD_DESC: e.target.value };
                  }
                  return { ...item };
                });
              })
            }
            value={row.DASHBOARD_DESC}
          />
        </div>
      </AvForm>
    );
  };

  const manualKeyAlarmMedium = (cellContent, row) => {
    return (
      <AvForm className="needs-validation">
        <div>
          <AvField
            type="textarea"
            name="DASHBOARD_DESC"
            errorMessage="Enter Case"
            className="form-control"
            maxLength="230"
            // style={{ border: "solid 1px #FFFFFF", color: "#FFFFFF" }}
            // backgroundColor: "#FFFFFF", color: "#000000"
            // validate={{ required: { value: true } }}
            readOnly={row.DASHBOARD_FLAG == false}
            onChange={e =>
              setListAlarmMedium(prevData => {
                return prevData.map(item => {
                  if (item.PID === row.PID) {
                    return { ...item, DASHBOARD_DESC: e.target.value };
                  }
                  return { ...item };
                });
              })
            }
            value={row.DASHBOARD_DESC}
          />
        </div>
      </AvForm>
    );
  };


  useEffect(() => {
    setSelectedListUrgent(listAlarmUrgent.filter(item => item.DASHBOARD_FLAG == 1).map(item => item.PID))
    if (listAlarmUrgent.filter(item => item.DASHBOARD_FLAG == 1).length == 3) {
      setDisabledListUrgent(listAlarmUrgent.filter(item => item.DASHBOARD_FLAG == 0).map(item => item.PID))
    } else {
      setDisabledListUrgent([])
    }
  }, [listAlarmUrgent]);
  useEffect(() => {
    setSelectedListMedium(listAlarmMedium.filter(item => item.DASHBOARD_FLAG == 1).map(item => item.PID))
    if (listAlarmMedium.filter(item => item.DASHBOARD_FLAG == 1).length == 3) {
      setDisabledListMedium(listAlarmMedium.filter(item => item.DASHBOARD_FLAG == 0).map(item => item.PID))
    } else {
      setDisabledListMedium([])
    }
  }, [listAlarmMedium]);
  // Action Button//

  //render Index//
  const countIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleAlarmMedium = (row, rowIndex) => {
    const style = {};
    if (rowIndex % 2 == 0) {
      // style.backgroundColor = '#E0E0E0'
      style.color = "#FFFFFF";
      // style.fontWeight = 'bold';
    } else {
      style.backgroundColor = "#ff672d52";
      style.color = "#FFFFFF";
      // style.fontWeight = 'bold';
    }
    // style.fontWeight = 'bold';
    return style;
  };

  const rowStyleAlarmUrgent = (row, rowIndex) => {
    const style = {};
    if (rowIndex % 2 == 0) {
      // style.backgroundColor = '#E0E0E0'
      style.color = "#FFFFFF";
      // style.fontWeight = 'bold';
    } else {
      style.backgroundColor = "#ff2d2d4d";
      style.color = "#FFFFFF";
      // style.fontWeight = 'bold';
    }
    // style.fontWeight = 'bold';
    return style;
  };
  const handleOnSelectUrgent = (row, isSelect) => {
    if (
      listAlarmUrgent.filter(item => item.DASHBOARD_FLAG == 1).length <= 2 ||
      !isSelect
    ) {
      setListAlarmUrgent(prevData => {
        return prevData.map(item => {
          if (item.PID === row.PID) {
            return { ...item, DASHBOARD_FLAG: item.DASHBOARD_FLAG == 0 ? 1 : 0 };
          }
          return { ...item };
        });
      });
      return true;
    } else {
      toggleModalMessage("Limit 3 Alarm.");
      return false;
    }
  };
  const selectRowUrgent = {
    mode: "checkbox",
    // clickToSelect: true,
    onSelect: handleOnSelectUrgent,
    hideSelectAll: true,
    selected: selectedListUrgent,
    nonSelectable: disabledListUrgent,
    bgColor: "#ff000038",
    nonSelectableStyle: { backgroundColor: '#2A3042' }

  };
  //headerColumn
  const columnsUrgent = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "3%",
        backgroundColor: "#ff000073",
        // FF6565
      },
      formatter: countIndexRow,
    },
    // {
    //   dataField: "selectAlarmUrgent",
    //   text: "Selected",
    //   headerAlign: "center",
    //   editable: false,
    //   align: "center",
    //   headerStyle: {
    //     width: "2%",
    //     backgroundColor: "#ff000073"
    //   },
    //   formatter: selectAlarmUrgent,
    //   // sort: true,
    // },
    {
      dataField: "TAG_NAME",
      text: "Tag Name",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        backgroundColor: "#ff000073",
      },
      sort: true,
    },
    {
      dataField: "TAG_DESC",
      text: "Description",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "20%",
        backgroundColor: "#ff000073",
      },
      // sort: true,
    },
    {
      dataField: "TOTAL",
      text: "Count",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "6%",
        backgroundColor: "#ff000073",
      },
      // sort: true,
    },
    {
      dataField: "USER_GROUP",
      text: "User",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "6%",
        backgroundColor: "#ff000073",
      },
      // sort: true,
    },
    // {
    //   dataField: "REGION_CODE",
    //   text: "Region",
    //   headerAlign: "center",
    //   editable: false,
    //   align: "center",
    //   headerStyle: {
    //     width: "6%",
    //     backgroundColor: "#ff000073",
    //   },
    //   // sort: true,
    // },
    {
      dataField: "STATE",
      text: "State",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "6%",
        backgroundColor: "#ff000073",
      },
      // sort: true,
    },
    {
      dataField: "RTU_CODE",
      text: "RTU Code",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "2%",
        backgroundColor: "#ff000073",
      },
      // sort: true,
    },
    {
      dataField: "df1",
      text: "Cause",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "40%",
        backgroundColor: "#ff000073",
      },
      formatter: manualKeyAlarmUrgent,
    },
  ];
  const handleOnSelectMedium = (row, isSelect) => {
    if (
      listAlarmMedium.filter(item => item.DASHBOARD_FLAG == 1).length <= 2 ||
      !isSelect
    ) {
      setListAlarmMedium(prevData => {
        return prevData.map(item => {
          if (item.PID === row.PID) {
            return { ...item, DASHBOARD_FLAG: item.DASHBOARD_FLAG == 0 ? 1 : 0 };
          }
          return { ...item };
        });
      });
      return true;
    } else {
      toggleModalMessage("Limit 3 Alarm.");
      return false;
    }
  };
  const selectRowMedium = {
    mode: "checkbox",
    // clickToSelect: true,
    onSelect: handleOnSelectMedium,
    hideSelectAll: true,
    selected: selectedListMedium,
    nonSelectable: disabledListMedium,
    bgColor: "#dd7a54bf",
    nonSelectableStyle: { backgroundColor: '#2A3042' }
  };
  const columnsMedium = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "3%",
        backgroundColor: "#ff5b1994",
        // FF9D65
      },
      formatter: countIndexRow,
    },

    {
      dataField: "TAG_NAME",
      text: "Tag Name",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "15%",
        backgroundColor: "#ff5b1994",
      },
      sort: true,
    },
    {
      dataField: "TAG_DESC",
      text: "Description",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "20%",
        backgroundColor: "#ff5b1994",
      },
      // sort: true,
    },
    {
      dataField: "TOTAL",
      text: "Count",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "6%",
        backgroundColor: "#ff5b1994",
      },
      // sort: true,
    },
    {
      dataField: "USER_GROUP",
      text: "User",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "6%",
        backgroundColor: "#ff5b1994",
      },
      // sort: true,
    },
    // {
    //   dataField: "REGION_CODE",
    //   text: "Region",
    //   headerAlign: "center",
    //   editable: false,
    //   align: "center",
    //   headerStyle: {
    //     width: "6%",
    //     backgroundColor: "#ff5b1994",
    //   },
    //   // sort: true,
    // },
    {
      dataField: "STATE",
      text: "State",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "6%",
        backgroundColor: "#ff5b1994",
      },
      // sort: true,
    },
    {
      dataField: "RTU_CODE",
      text: "RTU Code",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        width: "2%",
        backgroundColor: "#ff5b1994",
      },
      // sort: true,
    },
    {
      dataField: "df1",
      text: "Cause",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "40%",
        backgroundColor: "#ff5b1994",
      },
      formatter: manualKeyAlarmMedium,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    resetModel();
  }, []);
  //onInit//

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
    setShowDate(moment(searchModel.SELECT_DATE).add(-1, 'day').format("YYYY-MM-DD"))
  };

  const fetchData = async searchData => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_ALARM_DATA, { SELECT_DATE: moment(searchData.SELECT_DATE).add(-1, 'day').format("YYYY-MM-DD") });
      // console.log(res);
      if (
        res.data.alarmTop10MediumList != null &&
        res.data.alarmTop10UrgentList != null
      ) {
        // setListAlarmMedium(res.data.alarmTop10MediumList.map(obj => ({ ...obj, DASHBOARD_FLAG: obj.DASHBOARD_FLAG == 0 ? false : true, DASHBOARD_DESC : obj.DASHBOARD_DESC == null ? "" : obj.DASHBOARD_DESC })));
        // setListAlarmUrgent(res.data.alarmTop10UrgentList.map(obj => ({ ...obj, DASHBOARD_FLAG: obj.DASHBOARD_FLAG == 0 ? false : true, DASHBOARD_DESC : obj.DASHBOARD_DESC == null ? "" : obj.DASHBOARD_DESC })));
        setListAlarmMedium(
          res.data.alarmTop10MediumList.map(obj => ({
            ...obj,
            DASHBOARD_FLAG: obj.DASHBOARD_FLAG == 0 ? 0 : 1,
            DASHBOARD_DESC:
              obj.DASHBOARD_DESC == null ? "" : obj.DASHBOARD_DESC,
          }))
        );
        setListAlarmUrgent(
          res.data.alarmTop10UrgentList.map(obj => ({
            ...obj,
            DASHBOARD_FLAG: obj.DASHBOARD_FLAG == 0 ? 0 : 1,
            DASHBOARD_DESC:
              obj.DASHBOARD_DESC == null ? "" : obj.DASHBOARD_DESC,
          }))
        );
      } else {
        setListAlarmMedium([]);
        setListAlarmUrgent([]);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const refreshManual = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(MANUAL_REFRESH_ALARM, {});
      // console.log(res);
      if (res.resultCode == 200) {
        fetchData(searchModel);
        dispatch(messageAction.showMessage("Refresh Success."));
      } else {
        dispatch(messageAction.showMessage("Refresh Failed."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const saveData = async () => {
    let listData = [...listAlarmUrgent, ...listAlarmMedium];
    const bResult = listData.filter(row => row.DASHBOARD_FLAG == 1).every(row => row.DASHBOARD_DESC != "")
    if (bResult) {
      dispatch(loadingAction.showLoading());
      try {
        let res = await post(SAVE_LIST_ALARM_DATA, listData);
        // console.log(res);
        if (res.resultCode == 200) {
          dispatch(messageAction.showMessage("Save Success."));
          fetchData(searchModel);
        } else {
          dispatch(messageAction.showMessage(res.resultDescription));
        }
      } catch (error) {
        dispatch(messageAction.showMessage(error.message));
      }
      dispatch(loadingAction.hideLoading());
    } else {
      toggleModalMessage('Please fill in the fields from the selected data')
    }
  };

  //Function CURL

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Alarm Management")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Alarm Management
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="5" className="d-flex align-items-center">
                          <div className="page-title-box d-sm-flex p-0">
                            <h5 className="mb-sm-0 font-size-15">
                              Urgent Alarm Date :&nbsp;
                              {showDate == "" ||
                                showDate == null ||
                                showDate == undefined
                                ? ""
                                : //showDate
                                moment(showDate).format(
                                  "DD/MM/YYYY"
                                )
                              }

                              {/* {tempSearch.SELECT_DATE == "" ||
                            tempSearch.SELECT_DATE == null ||
                            tempSearch.SELECT_DATE == undefined
                            ? ""
                            : moment(tempSearch.SELECT_DATE).format(
                              "DD/MM/YYYY"
                            )} */}
                            </h5>
                          </div>
                        </Col>
                        <Col sm="4">
                          <FormGroup className="row d-flex align-items-center justify-content-end">
                            <Label className="col-sm-2 col-form-label d-flex align-items-center justify-content-end p-0">
                              Date :
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                  maxDate: new Date(),
                                }}
                                onChange={value => {
                                  setTempSearch({
                                    ...tempSearch,
                                    SELECT_DATE: value[0],
                                  });
                                  setSearchModel({
                                    ...searchModel,
                                    SELECT_DATE: moment(value[0]).format(
                                      "YYYY-MM-DD"
                                    ),
                                    // SELECT_DATE: moment(value[0].setDate(value[0].getDate() - 1)).format("YYYY-MM-DD")
                                  });
                                }}
                                value={tempSearch.SELECT_DATE}
                              />
                            </Col>
                          </FormGroup>
                        </Col>

                        <Col sm="3" className="d-flex align-items-center justify-content-start p-0">
                          <div className="d-grid gap-2 d-md-block">
                            <Button
                              color="info"
                              onClick={() => onSearch()}
                            >
                              <i className="fas fa-search fa-lg"></i>
                              &nbsp; Search
                            </Button>


                            {permission.eALM && searchModel.SELECT_DATE == moment(new Date()).format("YYYY-MM-DD") && (
                              <Button
                                onClick={() => refreshManual()}
                                color="primary"
                                className="ms-2"
                              // disabled
                              >
                                <i className="mdi mdi-cloud-refresh fa-lg"></i>
                                &nbsp; Manual Refresh
                              </Button>
                            )}

                          </div>
                        </Col>
                      </Row>

                      <Row className="mt-2">
                        <hr />
                      </Row>

                      <Row>
                        {/* <TabContent
                        activeTab={activeTab}
                        className="p-3 text-muted"
                        >
                          <TabPane tabId="1"> */}
                        <Col sm="12">
                          <div>
                            <BootstrapTable
                              keyField="PID"
                              data={listAlarmUrgent}
                              columns={columnsUrgent}
                              headerClasses="header-table-urgent"
                              rowStyle={rowStyleAlarmUrgent}
                              selectRow={selectRowUrgent}
                              noDataIndication={"no results found"}
                            // defaultSorted={defaultSorted}
                            // pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>
                        {/* </TabPane>
                        </TabContent> */}
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <div className="page-title-box d-sm-flex align-items-center">
                        <h5 className="mb-sm-0 font-size-15">
                          Medium Alarm Date :&nbsp;
                          {showDate == "" ||
                            showDate == null ||
                            showDate == undefined
                            ? ""
                            : moment(showDate).format(
                              "DD/MM/YYYY"
                            )}
                          {/* {moment(tempSearch.SELECT_DATE).format("DD/MM/YYYY")} */}
                        </h5>
                      </div>
                      <Row>
                        <hr />
                      </Row>

                      <Row>
                        {/* <TabContent
                        activeTab={activeTab}
                        className="p-3 text-muted"
                        >
                          <TabPane tabId="1"> */}
                        <Col sm="12">
                          <div>
                            <BootstrapTable
                              keyField="PID"
                              data={listAlarmMedium}
                              columns={columnsMedium}
                              wrapperClasses="table-on-scroll"
                              headerClasses="header-table-medium"
                              rowStyle={rowStyleAlarmMedium}
                              selectRow={selectRowMedium}
                              noDataIndication={"no results found"}
                            // defaultSorted={defaultSorted}
                            // pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>
                        {/* </TabPane>
                        </TabContent> */}
                      </Row>

                      <Row>
                        <Col
                          sm="12"
                          className="d-flex align-items-center justify-content-end"
                        >
                          <div className="d-grid gap-2 d-md-block">
                            {permission.eALM && (
                              <Button
                                onClick={() => saveData()}
                                color="success"
                                className="btn w-md ms-2"
                              // disabled={readonly == true}
                              >
                                <i className="bx bx-save"> </i> &nbsp; Save
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div >
    </React.Fragment >
  );
}

AlarmManagement.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ AlarmManagement }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(AlarmManagement));
